"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onDropDownFilter = exports.SearchableDropDown = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _TextInput = _interopRequireDefault(require("../../TextInput"));
var _Icon = _interopRequireDefault(require("../../Icon"));
var _FilterFooter = _interopRequireDefault(require("./FilterFooter"));
var _searchText = _interopRequireDefault(require("./searchText"));
var _Menu = _interopRequireDefault(require("../../Menu"));
var _Checkbox = _interopRequireDefault(require("../../Checkbox"));
var _Radio = require("../../Radio");
var _StyledFilterDropdown = require("../styled/StyledFilterDropdown");
var _MenuItemText = _interopRequireDefault(require("./MenuItemText"));
var _ykbUtils = require("ykb-utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var MenuItem = _Menu.default.Item;
var generateDropDownDataArray = function generateDropDownDataArray(tableData, dataIndex, isActiveRenderMethod) {
  var valueList = [];
  return tableData.reduce(function (acc, item) {
    var value = item[dataIndex];
    var data = {
      value: value,
      text: value
    };
    if (isActiveRenderMethod) data = _objectSpread(_objectSpread({}, item), data);
    var isExist = valueList.indexOf(data.value) > -1;
    if (!isExist) {
      acc.push(data);
      valueList.push(data.value);
    }
    return acc;
  }, []);
};
var SearchableDropDown = exports.SearchableDropDown = /*#__PURE__*/function (_Component) {
  function SearchableDropDown(props) {
    var _this;
    (0, _classCallCheck2.default)(this, SearchableDropDown);
    _this = _callSuper(this, SearchableDropDown, [props]);
    (0, _defineProperty2.default)(_this, "setSelectedKeys", function (_ref) {
      var selectedKeys = _ref.selectedKeys;
      _this.setState({
        selectedKeys: selectedKeys
      });
    });
    (0, _defineProperty2.default)(_this, "handleRadioCheckboxClick", function (e) {
      e.stopPropagation();
      if (e.nativeEvent.stopImmediatePropagation) {
        e.nativeEvent.stopImmediatePropagation();
      }
    });
    (0, _defineProperty2.default)(_this, "renderText", function (item, index) {
      var _this$props = _this.props,
        dataIndex = _this$props.dataIndex,
        render = _this$props.render,
        filters = _this$props.filters;
      var isActiveRenderMethod = typeof render === 'function' && !Array.isArray(filters);
      var renderedValue = isActiveRenderMethod ? render(item[dataIndex], item, index) : item.text;
      return /*#__PURE__*/_react.default.isValidElement(renderedValue) ? renderedValue : item.text;
    });
    var _isActiveRenderMethod = typeof props.render === 'function' && !Array.isArray(props.filters);
    _this.state = {
      query: '',
      selectedKeys: props.selectedKeys || [],
      data: props.filters || generateDropDownDataArray(props.data, props.dataIndex, _isActiveRenderMethod)
    };
    _this.onTextChange = _this.onTextChange.bind(_this);
    return _this;
  }
  (0, _inherits2.default)(SearchableDropDown, _Component);
  return (0, _createClass2.default)(SearchableDropDown, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.selectedKeys !== prevProps.selectedKeys) {
        this.setState({
          query: '',
          selectedKeys: this.props.selectedKeys || []
        });
      }
      if (prevProps.data !== this.props.data || prevProps.filters !== this.props.filters) {
        var isActiveRenderMethod = typeof this.props.render === 'function' && !Array.isArray(this.props.filters);
        this.setState({
          data: this.props.filters || generateDropDownDataArray(this.props.data, this.props.dataIndex, isActiveRenderMethod)
        });
      }
    }
  }, {
    key: "onTextChange",
    value: function onTextChange(e) {
      this.setState({
        query: e.target.value
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        setSelectedKeys = _this$props2.setSelectedKeys,
        _confirm = _this$props2.confirm,
        _clearFilters = _this$props2.clearFilters,
        locale = _this$props2.locale,
        multiple = _this$props2.multiple,
        prefixCls = _this$props2.prefixCls;
      var _this$state = this.state,
        query = _this$state.query,
        selectedKeys = _this$state.selectedKeys,
        data = _this$state.data;
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_StyledFilterDropdown.StyledFilterContentContainer, null, /*#__PURE__*/_react.default.createElement(_TextInput.default, {
        value: query,
        onChange: this.onTextChange,
        size: "small",
        suffix: /*#__PURE__*/_react.default.createElement(_Icon.default, {
          name: "search"
        })
      })), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_Menu.default, {
        multiple: multiple,
        onSelect: this.setSelectedKeys,
        onDeselect: this.setSelectedKeys,
        selectedKeys: selectedKeys,
        getPopupContainer: function getPopupContainer(triggerNode) {
          return triggerNode.parentNode;
        },
        withoutStyle: true,
        prefixCls: prefixCls
      }, data.filter(function (item) {
        return (0, _searchText.default)(item.text, query);
      }).map(function (item, index) {
        if (!item || (0, _ykbUtils.isNullOrUndefined)(item.value)) return null;
        return /*#__PURE__*/_react.default.createElement(MenuItem, {
          key: item.value
        }, /*#__PURE__*/_react.default.createElement(_StyledFilterDropdown.MenuItemContentWrapper, null, /*#__PURE__*/_react.default.createElement(_StyledFilterDropdown.MenuItemRadioCheckboxWrapper, null, multiple ? /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
          onClick: _this2.handleRadioCheckboxClick,
          checked: selectedKeys.indexOf(item.value.toString()) >= 0
        }) : /*#__PURE__*/_react.default.createElement(_Radio.Radio, {
          onClick: _this2.handleRadioCheckboxClick,
          checked: selectedKeys.indexOf(item.value.toString()) >= 0
        })), /*#__PURE__*/_react.default.createElement(_MenuItemText.default, null, _this2.renderText(item, index))));
      }))), /*#__PURE__*/_react.default.createElement(_FilterFooter.default, {
        locale: locale,
        confirm: function confirm() {
          setSelectedKeys(selectedKeys);
          _confirm();
        },
        clearFilters: function clearFilters() {
          _this2.setState({
            query: '',
            selectedKeys: []
          }, function () {
            setSelectedKeys([]);
            _clearFilters();
          });
        }
      }));
    }
  }]);
}(_react.Component);
var onDropDownFilter = exports.onDropDownFilter = function onDropDownFilter(dataIndex, value, record) {
  if (Array.isArray(value)) {
    return value.contains(record[dataIndex].toString());
  }
  return !(0, _ykbUtils.isNullOrUndefined)(record[dataIndex]) && record[dataIndex].toString() === value.toString();
};